const E403 = () => (
  <div className="error-container error-403">
    <h1>403</h1>
    <p className="title">Forbidden</p>
    <p>You don't have permission to view this page.</p>
  </div>
);

export default E403;